import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/SebaPegoraro/SebaPegoraro.jpeg";
import AyudemeImg from "ProfilePictures/SebaPegoraro/ayudeme_por_favor.jpg";
import FullstackImg from "ProfilePictures/SebaPegoraro/Fullstack_devs.jpeg";

const SebastianPegoraro: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <div className='d-flex flex-row align-items-center mb-2'>
        <div className='container'>
          <div className='row'>
            <img
              className='rounded-circle mr-2'
              width={92}
              alt='Foto de perfil de Seba Pegoraro'
              height={92}
              src={ProfilePicture}
            />
            <div>
              <h1>Seba Pegoraro</h1>
              <h3 className='text-muted'>Backend Team</h3>
            </div>
            <div className='col-12'>
              <img className='img-rounded img-responsive' src={FullstackImg} />
            </div>
            <div className='col-12'>
              <p>A ver camaradas esto va a ser rápido:</p>
              <p>1 - Desarrollador Full-Stack de Resistencia-Chaco</p>
              <p>
                2 - Buena experiencia con PHP - Symfony, MySQL, Javascript. Poca
                experiencia con Java, C#.
              </p>
              <p>
                3 - Me gusta mirar series, peliculas y animes. Juego videojuegos
                hace 20 años. A veces hablo mucho.
              </p>
              <p>Zip - Zap Termine... Esto es ser un profesional niña.</p>
            </div>
            <div className='col-12'>
              <img className='img-rounded img-responsive' src={AyudemeImg} />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default new Content({
  Component: SebastianPegoraro,
  title: "Sebastian Pegoraro",
  route: "seba-pegoraro",
  tags: ["semi-senior"]
});
